export const en = {
    meetingRooms: {
        alerts: {
            create: {
                title: "Create Meeting Room",
                text: "Are you sure you want to create <b>%{meetingRoom}</b>",
                success: {
                    title: "Meeting Room Created Successfully",
                    text: "<b>%{meetingRoom}</b> was created successfully",
                },
                error: {
                    title: "Meeting Room Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Meeting Room",
                text: "Are you sure you want to delete <b>%{meetingRoom}</b>",
                success: {
                    title: "Meeting Room Deleted Successfully",
                    text: "You will now be redirected to the Meeting Rooms page",
                },
                error: {
                    title: "Meeting Room Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Meeting Room",
                text: "Are you sure you want to edit <b>%{meetingRoom}</b>",
                success: {
                    title: "Meeting Room Edited Successfully",
                    text: "<b>%{meetingRoom}</b> was edited successfully",
                },
                error: {
                    title: "Meeting Room Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        types: {
            basic: "Basic",
            company: "Company",
            region: "Region",
            building: "Building",
            floor: "Floor",
            meetingRoom: "Meeting Room"
        },
        status: {
            enabled: "Active",
            disabled: "Disabled",
            disconnected: "Disconnected"
        },
        list: {
            name: "Name",
            parent: "Floor",
            email: "Email",
            capacity: "Capacity",
            status: "Status",
            operationTimeStart: "Opens at",
            operationTimeEnd: "Closed at"
        },
        form: {
            subForm: {
                email: "E-mail",
                openingTime: "Opening Time",
                closingTime: "Closing Time",
                status: "Status",
                provider: "Provider",
                minimumSchedulingPeriod: "Minimum Scheduling Period",
                maxCapacity: "Maximum Capacity",
                area: "Area",
                allowsQuickBook: "Allow Quick Book",
                allowsQuickBookCancel: "Allow Quick Book Cancel",
                checkInTime: "Check-in Open",
                calendarDepth: "Weeks",
                maxMeetingTime: "Maximum Meeting Time",
                minMeetingTime: "Minimum Meeting Time",
                quickBookPeriod: "Quick Book Period",
                tolerance: "Tolerance",
                logoUrl: "Logo URL (link)"
            },
            helpers: {
                tolerance: "Minutes until auto checkout",
                weeks: "Synchronization period with Office"
            },
            headers: {
                create: "Create Meeting Room",
                edit: "Edit Meeting Room",
                view: "View Meeting Room"
            },
            name: {
                label: "Name",
            },
            type: {
                label: "Type",
            },
            parent: {
                label: "Parent",
            },
            email: {
                label: "Email",
            },
            entity: {
                label: "Entity",
            },
            status: {
                label: "Status",
                enabled: "Enabled",
                disabled: "Disabled",
            },
            language: {
                label: "Language",
            },
            timezone: {
                label: "Timezone",
            },
            temperature: {
                label: "Temperature",
            },
            people: {
                label: "People",
            }
        },
        errors: {
            invalidEmail: "Invalid email format",
            meetingRoomNoQuickBook: "Meeting room does not allow quick book.",
            emailAlreadyInUse: "Meeting room email is already in use."
        },
        scheduleEvents: {
            eventOrigin: 'Origin',
            eventType: 'Type',
            creationTimestamp: 'Date/Time',
            owner: 'User',
            description: 'Description',
            entryStartEnd: 'Schedule Entry',
            origins: {
                BACKOFFICE: 'BackOffice',
                SYSTEM: 'System',
                CONSOLE: 'Console',
                PROVIDER: 'Provider'
            },
            types: {
                CREATE: 'Create',
                QUICK_BOOK: 'Quick Book',
                EXTEND: 'Extend',
                UPDATE: 'Update',
                DELETE: 'Delete',
                SYNCHRONIZATION: 'Synchronization',
                CHECK_IN: 'Check-In',
                CHECK_OUT: 'Check-Out'
            }
        },
        permissions: {
            MEETING_ROOMS: "Meeting Rooms",
            CREATE_MEETING_ROOM: "Create meeting rooms",
            READ_MEETING_ROOM: "Read meeting rooms",
            UPDATE_MEETING_ROOM: "Update meeting rooms",
            DELETE_MEETING_ROOM: "Delete meeting rooms",
        }
    },
    scheduleEntries: {
        permissions: {
            SCHEDULE_ENTRIES: "Schedule Entries",
            READ_SCHEDULE_ENTRIES: "Read Schedule Entries",
            CREATE_SCHEDULE_ENTRIES: "Create Schedule Entries",
            UPDATE_SCHEDULE_ENTRIES: "Update Schedule Entries",
            DELETE_SCHEDULE_ENTRIES: "Delete Schedule Entries"
        }
    },
};